// Shared constants for the application

export const CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'RUB', symbol: '₽', name: 'Russian Ruble' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'GEL', symbol: '₾', name: 'Georgian Lari' },
  { code: 'UAH', symbol: '₴', name: 'Ukrainian Hryvnia' },
  { code: 'HUF', symbol: 'Ft', name: 'Hungarian Forint' },
  { code: 'PLN', symbol: 'zł', name: 'Polish Złoty' },
  { code: 'ILS', symbol: '₪', name: 'Israeli New Shekel' },
] as const

export type CurrencyCode = typeof CURRENCIES[number]['code']

// Product conditions
export const PRODUCT_CONDITIONS = [
  { value: 'new', label: 'New' },
  { value: 'like_new', label: 'Like New' },
  { value: 'used', label: 'Used' },
  { value: 'refurbished', label: 'Refurbished' },
  { value: 'damaged', label: 'Damaged' },
  { value: 'for_parts', label: 'For Parts' },
] as const

export type ProductCondition = typeof PRODUCT_CONDITIONS[number]['value']

// Payment methods
export const PAYMENT_METHODS = [
  { value: 'cash', label: 'Cash' },
  { value: 'card', label: 'Card' },
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'crypto', label: 'Cryptocurrency' },
  { value: 'paypal', label: 'PayPal' },
] as const

export type PaymentMethod = typeof PAYMENT_METHODS[number]['value']

// Supported languages
export const LANGUAGES = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский' },
  { code: 'uk', name: 'Ukrainian', nativeName: 'Українська' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
] as const

export type LanguageCode = typeof LANGUAGES[number]['code']
